import '../sass/Skills.scss'
import { skillGroups } from '../data/skills'

function Skills() {
    return (
        <div className="skills" id='skills'>
            <h2>MES COMPÉTENCES :</h2>
            {skillGroups.map(group => (
                <div className='skill-group' key={group.category}>
                    <p className='skill-category'>{group.category}</p>
                    <div className='skill-tags'>
                        {group.items.map(item => (
                            <span className='skill-tag' key={item}>{item}</span>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    )
}
export default Skills
